export * from "-!../../../../../node_modules/cache-loader/dist/cjs.js!../../../../../node_modules/buble-loader/index.js??ref--2-1!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ResearchCategory.vue?vue&type=template&id=7368ffce"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/components/ResearchCategory.vue?vue&type=template&id=7368ffce
// module id = 410
// module chunks = 0